import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/landing/LegalPage";

export const Route = createFileRoute("/legal/kullanim-kosullari")({
  head: () => ({
    meta: [
      { title: "Пользовательское соглашение — TurkeyDrive" },
      { name: "description", content: "Kullanıcı Sözleşmesi / Пользовательское соглашение платформы TurkeyDrive." },
      { property: "og:title", content: "Пользовательское соглашение — TurkeyDrive" },
      { property: "og:description", content: "Kullanıcı Sözleşmesi / Пользовательское соглашение платформы TurkeyDrive." },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <LegalPage slug="kullanim-kosullari" />,
});
